import script from "./PointChargeSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./PointChargeSuccess.vue?vue&type=script&setup=true&lang=js"

import "./PointChargeSuccess.vue?vue&type=style&index=0&id=1af08bce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1af08bce"]])

export default __exports__